import httpService from "V2.0/services/httpService";

const endPoints = {
  GET_VOICES: "/voices/whitelabelGetVoices",
  GET_VOICE: "/voices/whitelabelGetVoice",
  UPDATE_VOICE: "/voices/whitelabelUpdateVoice",
  DELETE_VOICE: "/voices/whitelabelDeleteVoice",
  ADD_VOICE: "/voices/whitelabelAddVoice",
  SEARCH_VOICES: "/voices/whitelabelSearchVoices",
  DESIGN_VOICE: "/voices/whitelabelDesignVoice",
  CREATE_DESIGNED_VOICE: "voices/whitelabelCreateDesignedVoice",
  CREATE_VOICE_CLONE: "voices/whitelabeCreateVoiceClone",
};

function getVoices() {
  return httpService.get(`${endPoints.GET_VOICES}`);
}

function getVoice({ voiceId }) {
  return httpService.get(`${endPoints.GET_VOICE}/${voiceId}`);
}

function updateVoice({ voiceId, payload }) {
  return httpService.put(`${endPoints.UPDATE_VOICE}/${voiceId}`, payload);
}

function searchVoices({ payload }) {
  return httpService.post(`${endPoints.SEARCH_VOICES}`, payload);
}

function addVoice({ payload }) {
  return httpService.post(`${endPoints.ADD_VOICE}`, payload);
}

function deleteVoice({ voiceId }) {
  return httpService.delete(`${endPoints.DELETE_VOICE}/${voiceId}`);
}

function designVoice({ payload }) {
  return httpService.post(`${endPoints.DESIGN_VOICE}`, payload);
}

function createDesignedVoice({ payload }) {
  return httpService.post(`${endPoints.CREATE_DESIGNED_VOICE}`, payload);
}

function createVoiceClone({ payload }) {
  return httpService.post(`${endPoints.CREATE_VOICE_CLONE}`, payload);
}

export {
  getVoices,
  getVoice,
  updateVoice,
  searchVoices,
  addVoice,
  deleteVoice,
  designVoice,
  createDesignedVoice,
  createVoiceClone,
};
